export default "__VITE_ASSET__BjRSIYXS__"